export async function copyToClipboard(t: string) {
  try {
    await navigator.clipboard.writeText(t)
  } catch {
    const ta = document.createElement('textarea')
    ta.value = t ?? ''
    ta.style.position = 'absolute'
    ta.style.left = '-9999px'
    ta.style.opacity = '0'
    ta.style.zIndex = '-1'
    document.body.appendChild(ta)
    setTimeout(() => {
      ta.focus()
      ta.select()
      ta.setSelectionRange(0, t.length)
      try {
        document.execCommand('copy')
        console.log('Text copied to clipboard:', ta.value)
      } catch (n) {
        console.log('Failed to copy text: ', n)
      }
      ta.remove()
    }, 0)
  }
}
